import Vue from "vue";
import Vuex from "vuex";
import menuUtils from "@/common/utils/menuUtils";
import router from "@/router";

import app from "./modules/app";
import menu from "./modules/menu";
import book from "./modules/book";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    //引入模块
    menu,
    book,
    app
  },
  state: {
    //可存储全局通用的数据
	userInfo: "",
  },
  getters: {
    getRoutes: state => {
      let routes = [];
      menuUtils(routes, state.menu.menuList);
      return routes;
    }
  },
  mutations: {
    goBack() {
      this.$router.go(-1);
    },
    LOGIN(state, data) {
      // localStorage.token = data;
      sessionStorage.userInfo = JSON.stringify(data.userInfo);
      state.userInfo = data.userInfo;
      state.token = data.token;
        localStorage.token = state.token;
      // localStorage.setItem("token", state.token);
    },
    LOGOUT(state, data) {
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("menuList");
      sessionStorage.removeItem("btnPerms");
      localStorage.removeItem("token");
    },
    TITLE(state, data) {
      document.title = data;
    }
  }
});
